import { render, staticRenderFns } from "./PriceNavigation.vue?vue&type=template&id=d806b06a&scoped=true"
import script from "./PriceNavigation.vue?vue&type=script&lang=js"
export * from "./PriceNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d806b06a",
  null
  
)

export default component.exports